import { render, staticRenderFns } from "./ListPolice.vue?vue&type=template&id=af9264d2"
import script from "./ListPolice.vue?vue&type=script&lang=js"
export * from "./ListPolice.vue?vue&type=script&lang=js"
import style0 from "./ListPolice.vue?vue&type=style&index=0&id=af9264d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports